import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Social Media Dashboard", -1)
const _hoisted_2 = { class: "theme-switcher" }
const _hoisted_3 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", null, [
      _hoisted_1,
      _createElementVNode("h2", null, "Total Followers: " + _toDisplayString(_ctx.totalFollowers), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleTheme && _ctx.toggleTheme(...args))),
        for: "theme-chooser"
      }, "Dark Mode"),
      _createElementVNode("input", {
        id: "theme-chooser",
        value: _ctx.currentTheme,
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onThemeChanged && _ctx.onThemeChanged(...args))),
        type: "range",
        min: "1",
        "aria-valuemin": "1",
        max: "2",
        "aria-valuemax": "2",
        "aria-label": "Theme Options"
      }, null, 40, _hoisted_3)
    ])
  ]))
}